import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

/*
This component is called by the UAA when following the redirect URL post authentication
It pulls the tokens from the web fragment ( ?#access_token=...&id_token=... ) and stores them in local storage
 */
@Component({ template: '' })

export class OAuthCallbackComponent implements OnInit {

	constructor(private _router: Router) {
		this._router = _router;
	}

	ngOnInit() {
		window.location.replace("#/home-page")
	}
}

